import React from 'react'
import styles from './Banner.module.scss'
import classNames from 'classnames/bind';

const cx = classNames.bind(styles)

function Banner() {
    return (
        <section className={cx('banner')}>
            <img src='/imgs/tvremote.png' alt='' className={cx('logo')} />
            <div className={cx('content')}>
                <h1>TV Remote: Universal Remote</h1>
                <h4>
                    An Android application developed by Starnest JSC.
                    <br />
                    The application allows users to control compatible Smart TVs directly from their mobile devices. Users can adjust the volume, change channels, navigate TV menus, enter text, use voice search, mirror their phone screen, and cast supported media files to the TV.
                </h4>
            </div>
            <div className={cx('actions')}>
                <button>
                    <a href="https://play.google.com/store/apps/details?id=com.tvremote.starnest">FREE DOWNLOAD</a>
                </button>
                <div className={cx('social')}>
                    <p>Follow Me</p>
                    <div className={cx('social-icons')}>
                        <img src='/imgs/mail/icons/fb.svg' alt="facebook" />
                        <img src='/imgs/mail/icons/insta.svg' alt="instagram" />
                        <img src='/imgs/mail/icons/youtube.svg' alt="youtube" />
                        <img src='/imgs/mail/icons/tiktok.svg' alt="tiktok" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner
